module.exports = __webpack_public_path__ + "static/sphere_floattank_bg-3af92f4ec1f083483e2d033b6d7f500f.png";